import React from "react";

import { IconMap } from "./IconMap";
import { IconDictionary } from "./types";

export const regular = (
  color: string | undefined,
  icon: IconDictionary | (string & Record<never, never>)
) => {
  const Icon = IconMap[icon];
  if (!Icon) {
    return null;
  }
  return (
    <>
      <g
        fill="none"
        stroke={color}
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeMiterlimit="4"
        strokeWidth="1.5"
      >
        <Icon variant="regular" color={color} />
      </g>
    </>
  );
};

export const thin = (
  color: string | undefined,
  icon: IconDictionary | (string & Record<never, never>)
) => {
  const Icon = IconMap[icon];
  if (!Icon) {
    return null;
  }
  return (
    <>
      <g
        fill="none"
        stroke={color}
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeMiterlimit="4"
        strokeWidth="1"
      >
        <Icon variant="thin" color={color} />
      </g>
    </>
  );
};

export const filled = (
  color: string | undefined,
  icon: IconDictionary | (string & Record<never, never>)
) => {
  const Icon = IconMap[icon];
  if (!Icon) {
    return null;
  }
  return (
    <>
      <g
        fill={color}
        strokeLinejoin="round"
        strokeLinecap="round"
        strokeMiterlimit="4"
      >
        <Icon variant="filled" color={color} />
      </g>
    </>
  );
};

export const IconTypes = {
  regular,
  thin,
  filled,
};
